module.exports = __webpack_public_path__ + "static/values-34b0b2d6f56aa69345ac0c737da75e26.jpeg";